import type { FollowInvite } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  FollowInviteState,
  useGetFollowInvites,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import type { SWRResponse } from "swr"
import useSWR from "swr"

import { useThisMinute } from "../time"
import { useFollowInvitesSWRKey } from "./useFollowInvitesSWRKey"

export function useFollowInvites(): SWRResponse<Array<FollowInvite>> {
  const followInvitesSWRKey = useFollowInvitesSWRKey()
  const getFollowInvites = useGetFollowInvites()
  const thisMinute = useThisMinute()

  const getFollowInvitesData = useMemo(
    () => !getFollowInvites ? null : (async () => {
      const response = await getFollowInvites({ params: {} })
      return response.filter(
        (invite: FollowInvite) => (invite.state === FollowInviteState.Invited ||
          invite.state === FollowInviteState.Created) &&
          invite.expires_at > thisMinute,
      )
    }),
    [
      getFollowInvites,
      thisMinute,
    ],
  )

  return useSWR<Array<FollowInvite>>(
    followInvitesSWRKey,
    getFollowInvitesData,
  )
}
